// StatusLegend.jsx
import React from 'react';
import {Box, Chip} from '@mui/material';
import statusColors from './statusColors';

export default function StatusLegend() {
    return (
        <Box sx={{display: 'flex', gap: 2, mt: 2}}>
            <Chip label="Pendente" sx={{bgcolor: statusColors.Pendente, color: '#fff'}} />
            <Chip label="Aprovado" sx={{bgcolor: statusColors.Aprovado, color: '#fff'}} />
            <Chip label="Rejeitado" sx={{bgcolor: statusColors.Rejeitado, color: '#fff'}} />
        </Box>
    );
}
